import React from 'react';
import Main from 'components/ui/Main/Main';
import useTranslate from 'components/hooks/useTranslate';
import Header from 'components/ui/Header/Header';
import { LangSwitcher } from 'components/ui/LangSwitcher/LangSwitcher';
import useMessages from 'components/hooks/useMessages';

function PublicPage(props: React.ComponentProps<'div'>): JSX.Element {
  const t = useTranslate();
  const messages = useMessages((t) => {
    return {
      langswitcher: {
        label: t('langswitcher.label'),
        fr: t('langswitcher.fr'),
        en: t('langswitcher.en'),
      },
    };
  }, []);

  return (
    <>
      <Header homeLink={<a href="/">{t('identity.home')}</a>} title={t('identity.baseline')}>
        <LangSwitcher className="is-floatingMd public-Page" messages={messages.langswitcher} />
      </Header>
      <Main>
        <div {...props} />
      </Main>
    </>
  );
}

export default PublicPage;
